/**
 * Настройки сайта, которые могут понадобиться поменять при развёртывании.
 */

/** Почта для обратной связи и сообщений о неверных замечаниях (ссылки mailto: в подвале и в отчёте). */
export const FEEDBACK_EMAIL = 'alexanderbakanovsky@yandex.ru';

/** Письмо в почтовой программе пользователя: сайт ничего не отправляет сам. */
export function mailtoLink(subject: string, body: string): string {
  return `mailto:${FEEDBACK_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
